import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/SteamAchievement.css';

const SteamAchievement = ({ title = 'First Social Event' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(showTimer);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="steam-achievement"
          initial={{ x: 400, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 400, opacity: 0 }}
          transition={{ type: 'spring', damping: 20, stiffness: 200 }}
        >
          <div className="steam-icon">
            <svg viewBox="0 0 24 24" fill="none" width="40" height="40">
              <circle cx="12" cy="12" r="10" stroke="#5c7e10" strokeWidth="2" fill="#1b2838" />
              <path d="M8 12.5l2.5 2.5 5.5-5.5" stroke="#5c7e10" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="steam-text">
            <span className="steam-label">Achievement Unlocked</span>
            <span className="steam-title">{title}</span>
          </div>
          <button className="steam-close" onClick={() => setVisible(false)} aria-label="Close">
            &times;
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SteamAchievement;
